// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-bottom-bar-mb{transition:transform .3s ease}.base-bottom-bar-mb .active img{filter:invert(12%) sepia(93%) saturate(4672%) hue-rotate(350deg) brightness(85%) contrast(108%)}.base-bottom-bar-mb.hide{transform:translateY(100%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
